import { BMText } from "@traveloka/district-bloom";
import { memo } from "react";
import BMView from "../../../../components/View/BMView";
import { FacilityItem } from "./types";

type Props = {
  item: FacilityItem;
};

function FacilityRow({ item: { type, title, description, getIcon } }: Props) {
  return (
    <BMView row spacing="sm" key={type}>
      {getIcon()}
      <BMView flex>
        <BMText variant="paragraphSmall">{title}</BMText>
        {description ? (
          <BMText variant="paragraphSmall" ink="BMStyleTextInkSecondary">
            {description}
          </BMText>
        ) : null}
      </BMView>
    </BMView>
  );
}

export default memo(FacilityRow);
